module.exports = __webpack_public_path__ + "img/3.65ff2799.png";